import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { I18nextProvider } from "react-i18next";
import i18n from "i18n";
import { LanguageProvider } from "context/LanguageContext";
import "index.css";
import { RecoilRoot } from "recoil";
import { MaterialUIControllerProvider } from "context";
import { AuthContextProvider } from "store/auth-context";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RecoilRoot>
        <I18nextProvider i18n={i18n}>
          <LanguageProvider>
            <MaterialUIControllerProvider>
              <AuthContextProvider>
                <App />
              </AuthContextProvider>
            </MaterialUIControllerProvider>
          </LanguageProvider>
        </I18nextProvider>
      </RecoilRoot>
    </BrowserRouter>
  </React.StrictMode>
);
